export default import.meta.ROLLDOWN_FILE_URL_xbK7eMRCAk_oU2ev6YOMdw